export enum ValidationErrorType {
    Required = 'required',
    Optionality = 'optionality',
    Length = 'length',
    DuplicatedKey = 'duplicated-key',
}
